import Control from "../../1. Core/Control";
import Delegate from "../../1. Core/Delegate";
import IconSelect from "../../1. Core/Controls/Select/IconSelect";
import ListGroupHeader from "../../1. Core/Controls/ListBox/ListGroupHeader";
import {EventTournament, SportType} from "../../10. Battle/types";
import NP from "../../1. Core/NP";
import {getTournaments, ITournament} from "../../10. Battle/Util";
import DateInput from "../../1. Core/Controls/DateInput/DateInput";
import {ServerAPI} from "../../1. Core/ServerAPI";
import Select from "../../1. Core/Controls/Select/Select";

let moment = require('moment');


export default class PlayerRatingFilterPanel extends Control {

    public EvFilterSortChanged: Delegate;
    private _eventCombo: Select;
    private _sortFieldCombo: IconSelect;
    private _sortDirectionCombo: IconSelect;
    private _sortLabel: ListGroupHeader;
    private _tournamentCombo: IconSelect;

    private _SportType: SportType;
    private _endDate: DateInput;
    private _stateDate: DateInput;

    _initFields(settings: object) {
        this._SportType = SportType.MMA;
        this.EvFilterSortChanged = new Delegate();
        super._initFields(settings);
    }

    constructor(settings: object) {
        super(settings);
        this._render();
    }

    _render() {
        this._initComponent('<div class="filter-panel"></div>');

        new ListGroupHeader({
            ParentNode: this._root,
            RK: 'Parameters',
            Class: 'app-list-group__subheader--accent'
        });

        this._tournamentCombo = new IconSelect({
            ParentNode: this._root,
            FloatingLabel: NP.RM.getString('Tournaments'),
            EvItemSelected: async () => {
                this.updateEvents()
                this._applyFiltersSort();

            }
        });

        this._eventCombo = new Select({
            ParentNode: this._root,
            FloatingLabel: NP.RM.getString('Event'),
            EvItemSelected: () => this._applyFiltersSort()
        });

        this._stateDate = new DateInput({
            ParentNode: this._root,
            Value: null,
            FloatingLabel: "Start Date",
            EvChanged: () => {
                this._applyFiltersSort();
            }
        });

        this._endDate = new DateInput({
            ParentNode: this._root,
            Value: null,
            FloatingLabel: "End Date",
            EvChanged: () => {
                this._applyFiltersSort();
            }
        });


        this._renderItems([this._root], this._ParentNode || document.documentElement);
        this.loadFilters();
    }

    setSortVisible(value: boolean) {
        NP.setIsVisible([this._sortLabel, this._sortDirectionCombo, this._sortFieldCombo], value)
    }

    async loadFilters() {
        let tournaments = await getTournaments(this._SportType) as ITournament[],
            items = tournaments.map(t => ({Value: t.Id, FontImage: NP.FontImages.event, Content: t.Name})),
            defaultItems = [{
                Value: null as any,
                FontImage: NP.FontImages.event,
                Content: NP.RM.getString('AllTournaments')
            }];
        this._tournamentCombo.clear();
        this._tournamentCombo.addItems(defaultItems);
        this._tournamentCombo.addItems(items)
        this._tournamentCombo.setSelectedIndex(0, false);
    }

    async updateEvents(tId: number = null)
    {
        let response = await ServerAPI.callUiApi("/t-events", {
            Count: 500,
            Offset: 0,
            TournamentId: tId || this._tournamentCombo.getValue(),
        }, 'POST') as { List: EventTournament[], AllCount: number };

        this._eventCombo.setItems(response.List.map(ev => ({Content: ev.Name, Value: ev.Id})));
    }

    _applyFiltersSort() {
        this.EvFilterSortChanged.fire(this, this.getFilterData())
    }

    getFilterData() {
        return {
            tournamentId: this._tournamentCombo.getValue(),
            startDate: this._stateDate.getValue() ? moment(this._stateDate.getValue()).format('YYYY-MM-DD') : null,
            endDate: this._endDate.getValue() ? moment(this._endDate.getValue()).format('YYYY-MM-DD') : null,
            eventId: this._eventCombo.getValue()
        }
    }

    setSortValues(sortField: string, sortDirection: number) {
        this._sortFieldCombo.setValue(sortField, false);
        this._sortDirectionCombo.setValue(sortDirection, false);
    }
}